(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-onboarding-exception-report', {
            parent: 'entity',
            params:{screen: 'CustomerOnboardingExceptionReport'},
            url: '/customer-onboarding-exception-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customer.customerOnBoardingExceptionReport" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-on-boarding-exception-report/customer-on-boarding-exception-report.html',
                    controller: 'CustomerOnBoardingExceptionReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('customerOnBoardingExceptionReport');
                    $translatePartialLoader.addPart('customer-registration');
                    $translatePartialLoader.addPart('auditLog');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
        
        
       
       };
    })();